module.exports = __webpack_public_path__ + "static/media/TN-Women-Shoes.17615ec1.svg";